import Dropdown from './LegacyDropdownAdapter';

export default Dropdown;
